// Updated HomeServicio.js with the same improved carousel layout
import React, { useEffect, useMemo, useState } from "react";
import { Box, IconButton } from "@mui/material";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import SettingsIcon from "@mui/icons-material/Settings";
import { grey } from "@mui/material/colors";

import servicio_imagen_1 from "../../images/servicio_image_1.png";

const API_url = process.env.REACT_APP_API_URL;

const HomeServicio = ({ infoCompany, defaultImg }) => {
	/* --- datos del contexto --- */
	const view2 = infoCompany?.view2 ?? {};

	const [position, setPosition] = useState(0);

	useEffect(() => {
		const timer = setInterval(() => {
			setPosition(valor => valor < 2 ? (valor + 1) : 0);
		}, 3000);

		return () => clearInterval(timer);
	}, []);

	/* --- array de imágenes (usa default cuando viene null) --- */
	const images = (view2.img_list ?? []).map((enlace) => enlace != null ? (API_url + String(enlace)) : defaultImg);

	return (
		<div className="services-company">
			<div className="services-top">
				<div className="top-one" style={{ width: "100%" }}>
					<div className="circles-service">
						<span className="cs-children circle-one-service"></span>
						<span className="cs-children circle-two-service"></span>
						<span className="cs-children circle-three-service"></span>
					</div>
					<div className="services-setting">
						<SettingsIcon sx={{ fontSize: 40, color: 'var(--theme-visit)' }} className="setting-icon" />
						<span>{view2?.title || "Establecimiento"}</span>
					</div>

					<div className="squares-service">
						{[...Array(36)].map((_, i) => (
							<span></span>
						))}
					</div>
				</div>
			</div>

			<div className="services-center">
				<div className="square-grid-two floating-square">
					{[...Array(6)].map((_, i) => (
						<div className="box-ser" style={{ background: 'var(--theme-visit)' }} key={i} />
					))}
				</div>

				<div className="shadow-service-slider">
					<div className="main-slider-service">
						<ul className="slider-main" style={{ width: '300%', height: '100%', transform: `translateX(-${position * 33}%)` }}>
							{
								images.map((urls) => (
									<li className="child-slider-prods" style={{ display: "flex", justifyContent: 'center', alignItems: 'center' }}>
										<img src={urls} style={{ height: '100%', width: '100%', objectFit: 'cover', objectPosition: 'center', opacity: '0.9' }} />
									</li>
								))
							}
						</ul>
					</div>
				</div>
			</div>

			<div className="services-bottom">
				<h2>
					{view2.text || (
						<>
							Construyendo un{" "}
							<span>
								servicio <br /> equipado más allá
							</span>{" "}
							de visión
						</>
					)}
				</h2>

				<div className="square-grid-container">
					{[...Array(6)].map((_, i) => (
						<div className="box-ser" style={{ background: 'var(--theme-visit)' }} key={i} />
					))}
				</div>
			</div>
		</div>
	);
};

export default HomeServicio;
